import Request from "@/shared/utils/_request";
class Order {
  constructor() { }
  getStatus() {
    return Request.post("/post/get-statuses");
  }
  //订单列表接口
  getList(payload) {
    return Request.post("/post/search", payload);
  }
  //订单详情接口
  getDetail(payload) {
    return Request.post("/post/detail", payload);
  }
  //关闭订单
  close(payload) {
    return Request.post("/post/close", payload);
  }
  //手里推荐
  deliveryAudit(payload) {
    return Request.post("/post/deliveryAudit", payload);
  }
  //审核通过
  audit(payload) {
    return Request.post("/post/audit", payload);
  }
//投递审核拒绝
deliveryAuditFail(payload) {
  return Request.post("/post/deliveryAuditFail", payload);
}
  //审核不通过
  auditFail(payload) {
    return Request.post("/post/auditFail", payload);
  }
  //推荐通过
  submit(payload) {
    return Request.post("/post/submit", payload);
  }
  //推荐不通过
  submitFail(payload) {
    return Request.post("/post/submitFail", payload);
  }
  //入职
  entered(payload) {
    return Request.post("/post/entered", payload);
  }
  //未入职
  enteredFail(payload) {
    return Request.post("/post/notEntered", payload);
  }
  //过保
  completed(payload) {
    return Request.post("/post/completed", payload);
  }
  /**
   * 归档
   * @param {{post_id}} payload
   */
  done(payload) {
    return Request.post("/post/un-settled", payload);
  }
  //不过保
  completedFail(payload) {
    return Request.post("/post/notCompleted", payload);
  }
  //面试通过
  interviewConfirm(payload) {
    return Request.post("/post/interview/confirm", payload);
  }
  //面试不通过
  interviewConfirmFailed(payload) {
    return Request.post("/post/interview/confirm-fail", payload);
  }
  interviewCancel(payload) {
    return Request.post("/post/interview/cancel", payload);
  }
  //安排面试
  arrangeInterview(payload) {
    return Request.post("/post/interview/create", payload);
  }
  getNewestInterview(payload) {
    return Request.post("/post/interview/getNewest", payload);
  }
  //OFFER
  offer(payload) {
    return Request.post("/post/offer/create", payload);
  }
  //沟通附件
  communicateAttach(payload) {
    return Request.post('/post/Interview/uploadAttachment', payload);
}

downloadFirstAttachment(payload) {
  return Request.post("/post/interview/downloadAttachment", payload,{
    responseType: 'arraybuffer'
  });
}
downloadOfferAttachment(payload) {
  return Request.post("/post/offer/downloadAttachment", payload,{
    responseType: 'arraybuffer'
  });
}
downloadZipAttachment(payload) {
  return Request.post("/post/post/downloadAttachment", payload,{
    responseType: 'arraybuffer'
  });
}
  //添加回款
  payment(payload) {
    return Request.post("/post/payment/create", payload);
  }
  //案情通告列表
  caseNotice(payload) {
    return Request.post("/job/case-notice/get-list", payload);
  }
  //灵活用工详情 -- 小程序
  columbusJobDetail(payload) {
    return Request.post("/columbus-job/request", payload);
  }
  //灵活用工报名审核 推荐 -- 小程序
  columbusRecommend(payload) {
    return Request.post("/columbus-job/request", payload);
  }
  //灵活用工报名审核 拒绝 -- 小程序
  columbusRejected(payload) {
    return Request.post("/columbus-job/request", payload);
  }
}

export const order = new Order();

function test() {
  return function (target, name, descriptor) {
    console.log(target, name, descriptor);
  };
}
